// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchInput_inputBoxClass__YtqYb {
  box-shadow: none !important;
  background: var(--black-color-v3);
}
.SearchInput_inputClass__07qRK {
  padding-left: 20px !important;
}
`, "",{"version":3,"sources":["webpack://./src/Components/molecules/SearchInput/SearchInput.module.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;AACA;EACE,6BAA6B;AAC/B","sourcesContent":[".inputBoxClass {\n  box-shadow: none !important;\n  background: var(--black-color-v3);\n}\n.inputClass {\n  padding-left: 20px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputBoxClass": `SearchInput_inputBoxClass__YtqYb`,
	"inputClass": `SearchInput_inputClass__07qRK`
};
export default ___CSS_LOADER_EXPORT___;
